<script>
import { mapGetters } from 'vuex'
import { themeConfigureImgUrl, textLenHandler } from '@/utils/common'

export default {
  name: 'TitleModule',
  props: {
    title: {
      type: String,
      default: ''
    },
    marginBottom: {
      type: String,
      default: '30'
    }
  },
  data() {
    return {
      admini: localStorage.getItem('admini'),
      titleOption: [
        {
          id: 1,
          width: '268',
          height: '44',
          maxTextLen: 11,
          titleColor: '#fff',
          hasShadow: false
        }, {
          id: 2,
          width: '242',
          height: '32',
          maxTextLen: 11,
          titleColor: '#000',
          hasShadow: true
        }, {
          id: 3,
          width: '290',
          height: '54',
          maxTextLen: 11,
          titleColor: '#fff',
          hasShadow: false
        }, {
          id: 4,
          width: '292',
          height: '45',
          maxTextLen: 11,
          titleColor: '#fff',
          hasShadow: false
        }, {
          id: 5,
          width: '236',
          height: '42',
          maxTextLen: 11,
          titleColor: '#fff',
          hasShadow: false
        }, {
          id: 6,
          width: '254',
          height: '35',
          maxTextLen: 11,
          titleColor: '#CC0A66',
          hasShadow: true
        }, {
          id: 8,
          width: '331',
          height: '66',
          maxTextLen: 11,
          titleColor: '#fff',
          hasShadow: false
        }, {
          id: 9,
          width: '333',
          height: '43',
          maxTextLen: 11,
          titleColor: '#fff',
          hasShadow: false
        }, {
          id: 10,
          width: '245',
          height: '40',
          maxTextLen: 11,
          titleColor: '#A1202C',
          hasShadow: false
        }, {
          id: 11,
          width: '315',
          height: '58',
          maxTextLen: 11,
          titleColor: '#5F977D',
          hasShadow: false
        }, {
          id: 12,
          width: '315',
          height: '51',
          maxTextLen: 11,
          titleColor: '#fff',
          hasShadow: false
        }
      ],

      currentNavObj2: {
        areaId: 110,
        arrayId: '58,59,60,61',
        id: 655,
        pageBg: require('imgs/pageBg/newPage12/view-bg-id12.png'),
        pageBgId: 12,
        path: '/newPage12',
        sortNumber: 12,
        templateName: '新增模板12',
        titleBg: require('imgs/pageBg/newPage12/title-id12.png'),
        titleLogo: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      getCurrentNavObj: 'config/getCurrentNavObj'
    }),
    currentNavObj() { return this.getCurrentNavObj },
    currentTitleOption() {
      return this.titleOption.filter(item => item.id === this.currentNavObj.pageBgId)[0]
    }
  },
  mounted() {
    // console.log('currentTitleOption', this.currentNavObj, this.currentTitleOption)
  },
  methods: {
    themeConfigureImgUrl, textLenHandler,
    templateNameFilter(title) {
      let titleStr = ''
      switch (title) {
        case '居委会成员': titleStr = this.admini === '社区' ? '居委会成员' : '村委会成员'
          break
        case '居民小组长 居民代表': titleStr = this.admini === '社区' ? '居民小组长 居民代表' : '村民小组长 村民代表'
          break
        default: titleStr = title
      }
      return titleStr
    }
  }
}
</script>

<template>
  <!-- background: `url(${themeConfigureImgUrl(currentNavObj.titleBg)}) no-repeat center`, -->
  <div
    class="modules-title"
    :class="{'shadow-style': currentTitleOption.hasShadow}"
    :style="{
      width: `${$px2rem(`${currentTitleOption.width}px`)}`,
      height: `${$px2rem(`${currentTitleOption.height}px`)}`,
      background: `url(${themeConfigureImgUrl(currentNavObj.titleBg)}) no-repeat center`,
      backgroundSize: '100% 100%',
      marginBottom: `${$px2rem(`${marginBottom}px`)}`
    }"
  >
    <el-image
      v-if="currentNavObj.titleLogo"
      class="title-logo"
      :src="currentNavObj.titleLogo | pageBgConfigure"
      alt="logo"
    />
    <p
      class="title-text"
      :style="{
        color: currentTitleOption.titleColor,
        marginLeft: `${$px2rem(`${currentNavObj.pageBgId === 1 ? 9 : 0}px`)}`
      }"
    >
      {{ textLenHandler(templateNameFilter(title), currentTitleOption.maxTextLen) }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.title-logo {
  width: 25px;
  height: 25px;
}
.modules-title {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background-size: 100% 100% !important;
}
.shadow-style {
  box-shadow: 0 3px 10px 0 rgba(7, 60, 0, 0.1);
}
.title-text {
  font-size: 20px;
  font-style: italic;
}
</style>
